import React from "react";
import { formatNumber } from "../../utils";
import FullRoundedButton from "../../commons/FullRoundedButton";

function OrderItemDetails({ orderItem, onViewClick, onInitiateClick }) {
  return (
    <div className="flex justify-between p-4 mb-4 bg-gray-50 rounded-lg hover:shadow-md transition-all">
      <div className="flex gap-4 items-start">
        <div className="h-[100px] w-[100px] max-md:w-[60px] max-md:h-[60px]">
          <img
            src={orderItem?.Product?.imageOne}
            className="h-full w-full object-cover rounded-md"
            alt={orderItem?.Product?.name}
            loading="lazy"
          />
        </div>
        <div className="flex flex-col gap-2">
          <h3 className="text-[16px] max-md:text-[14px] font-[600]">
            {orderItem?.Product?.name}
          </h3>
          <p className="text-[14px] max-md:text-[12px] text-gray-600">
            Seller: {orderItem?.Product?.Vendor?.businessName}
          </p>
          {orderItem?.color && (
            <p className="text-[14px] max-md:text-[12px] text-gray-600">
              Color: {orderItem?.color}
            </p>
          )}
          <p className="text-[14px] max-md:text-[12px] text-gray-600">
            Quantity: {orderItem?.quantity}
          </p>
        </div>
      </div>
      <div className="flex flex-col items-end gap-2">
        <p className="text-[16px] max-md:text-[14px] font-[600] text-[#FF9D21]">
          ₦{formatNumber(orderItem?.subTotalPrice)}
        </p>
        <FullRoundedButton
          label="View Product"
          onClick={onViewClick}
          className="bg-transparent text-[#FF9D21] hover:bg-[#FF9D21] hover:text-white border border-[#FF9D21] py-1 px-3 text-[14px] max-md:text-[12px]"
          type="button"
        />
        {orderItem?.status === "success" && !orderItem?.returnRequest && (
          <FullRoundedButton
            label="Return Item"
            onClick={() => onInitiateClick(orderItem)}
            className="bg-transparent text-red-500 hover:bg-red-500 hover:text-white border border-red-500 py-1 px-3 text-[14px] max-md:text-[12px]"
            type="button"
          />
        )}
        {orderItem?.returnRequest && (
          <span className="text-[14px] max-md:text-[12px] text-yellow-600">
            Return Requested
          </span>
        )}
      </div>
    </div>
  );
}

export default OrderItemDetails;